<template>
  <div class="content">
    <form class="form-horizontal" @submit.prevent="">
      <!--      <div class="row">-->
      <!--        <div class="col-sm-4" v-for="language in languages" @click="showLanguage(language)">-->
      <!--          <card> {{ language.fileName }}</card>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="row">
        <div class="col-sm-12">
          <base-radio name="text" inline v-model="mode">TEXT VIEW</base-radio>
          <base-radio name="json" inline v-model="mode">JSON VIEW</base-radio>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12" v-if="mode === 'text'">
          <div class="row">
            <base-button @click="addRow()" type="info">행 추가</base-button>
            <base-button @click="onSubmit" type="success">등록</base-button>
            <base-button @click="clearCache()" type="danger">캐시초기화</base-button>
            <base-button @click="setServerMessage()" type="danger">서버적용</base-button>
            <el-popover trigger="hover" placement="top">
              <div>
                <div class="popover-body">
                  ＊줄바꿈: \n <br />
                  ＊아티스트명: %artistName% <br />
                  ＊유저닉네임: %userName% <br />
                </div>
              </div>
              <base-button slot="reference"> ? </base-button>
            </el-popover>
            <el-popover trigger="hover" placement="top">
              <div>
                <div class="popover-body">
                  ＊입력한 문자열은 [등록] 버튼을 누르지 않으면 저장이 되지 않습니다<br />
                  ＊[서버 적용]을 눌러야 등록된 문자열이 반영됩니다<br />
                  ＊영어, 일본어 입력이 되지 않으면 한글 입력된 문자열이 보여집니다<br />
                  ＊한글, 영어, 일본어 모두 입력되지 않으면 앱에서는 해당 문자열이 보여지지 않습니다<br />
                  ＊키값이 중복될 경우, 가장 하단에 있는 키값으로 적용됩니다<br />
                  ＊숫자만으로 등록된 키는 하단으로 이동합니다.<br />
                </div>
              </div>
              <base-button slot="reference"> i </base-button>
            </el-popover>
          </div>
          <div class="row">
            <div class="col-sm-2">
              <label class="col-form-label">key</label>
            </div>
            <div class="col-sm-3">
              <label class="col-form-label">ko</label>
            </div>
            <div class="col-sm-3">
              <label class="col-form-label">en</label>
            </div>
            <div class="col-sm-3">
              <label class="col-form-label">ja</label>
            </div>
            <div class="col-sm-1"></div>
          </div>
          <hr />
          <draggable handle=".handle" v-model="reversed" @start="drag = true" @end="drag = false">
            <div class="row" v-for="(item, index) in reversed">
              <div class="col-sm-2">
                <base-input placeholder="key" v-model="item.key">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
              <div class="col-sm-3">
                <base-input placeholder="value" v-model="item.ko">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
              <div class="col-sm-3">
                <base-input placeholder="value" @change="changeMessage(index)" v-model="item.en">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
              <div class="col-sm-3">
                <base-input placeholder="value" @change="changeMessage(index)" v-model="item.ja">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
              <div class="col-sm-1 handle">
                <base-button @click="removeRow(index)" type="danger">-</base-button>
              </div>
            </div>
          </draggable>
        </div>
        <div class="col-sm-12" v-if="mode === 'json'">
          <div class="row">
            <div class="col-sm-4">
              <base-input placeholder="내용">
                <textarea class="form-control langData" rows="100" v-model="ko" />
              </base-input>
            </div>
            <div class="col-sm-4">
              <base-input placeholder="내용">
                <textarea class="form-control langData" rows="100" v-model="en" />
              </base-input>
            </div>
            <div class="col-sm-4">
              <base-input placeholder="내용">
                <textarea class="form-control langData" rows="100" v-model="ja" />
              </base-input>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <base-button @click="addRow()" type="info">행 추가</base-button>
          <base-button @click="onSubmit" type="success">등록</base-button>
          <base-button @click="clearCache()" type="danger">캐시초기화</base-button>
          <base-button @click="setServerMessage()" type="danger">서버적용</base-button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { BaseButton, BaseInput, Card } from "@/components/index";
import draggable from "vuedraggable";
import swal from "sweetalert2";

export default {
  components: {
    draggable,
    BaseInput,
    BaseButton,
  },
  async created() {
    // await this.getLanguageFiles();
    await this.getLanguageFilesInFolder();
    await this.showLanguages();
  },
  data() {
    return {
      mode: "text",
      list: [],
      reversed: [],
      ko: {},
      en: {},
      ja: {},
      languages: [],
    };
  },
  watch: {
    reversed: {
      deep: true,
      handler() {
        const ko = {};
        const en = {};
        const ja = {};
        this.list = this.reversed.slice().reverse();
        this.list.forEach((item) => {
          ko[item.key] = item.ko;
          en[item.key] = item.en;
          ja[item.key] = item.ja;
        });
        this.ko = JSON.stringify(ko, null, "\t");
        this.en = JSON.stringify(en, null, "\t");
        this.ja = JSON.stringify(ja, null, "\t");
      },
    },
  },
  methods: {
    async getLanguageFiles() {
      return this.$axios.get(`/language`).then((res) => {
        this.languages = res.data.data;
      });
    },
    async getLanguageFilesInFolder() {
      return this.$axios.get(`/language/folder`).then((res) => {
        this.languages = res.data.data;
      });
    },
    addRow() {
      this.reversed.unshift({});
    },
    removeRow(index) {
      this.reversed.splice(index, 1);
    },

    showLanguages() {
      for (const language of this.languages) {
        for (const [key, value] of Object.entries(language.data)) {
          let isDuplicatedKey = false;
          for (const item of this.list) {
            if (item.key === key) {
              item[language.fileName] = value;
              isDuplicatedKey = true;
              break;
            }
          }
          if (!isDuplicatedKey) {
            const obj = { key };
            obj[language.fileName] = value;
            this.list.push(obj);
          }
        }
      }
      this.reversed = this.list.slice().reverse();
    },
    async clearCache() {
      await this.$axios.post(`/language/invalidate`, this.lang);
      Toast.success("캐시가 초기화되었습니다");
    },
    async setServerMessage() {
      swal
        .fire({
          title: "서버적용",
          text: `서버에 적용 하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "적용",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            await this.$axios.post(`/language/server`);
            Toast.success("서버에 반영되었습니다");
          }
        });
    },
    changeMessage(index) {
      const ko = _.cloneDeep(this.list[index].ko);
      this.list[index].ko = ko + " ";
      this.list[index].ko = ko;
    },
    async onSubmit() {
      if (!this.isJsonString(this.ko) || !this.isJsonString(this.en) || !this.isJsonString(this.ja)) {
        Toast.error("유효하지 않은 JSON");
        return;
      }
      swal
        .fire({
          title: "등록 확인",
          text: `등록 하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "등록",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            await this.$axios.post(`/language`, { ko: this.ko, en: this.en, ja: this.ja });
            Toast.success("등록되었습니다");
          }
        });
      // TODO 중복키 alert
    },
    isJsonString(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
  },
};
</script>
<style>
textarea.langData {
  max-height: 500px;
}
</style>
